import axios from 'axios'

import former from './former'

export default {

    mixins: [
        former
    ],

    data () {
        return {
            poster: {
                submitted: false,
                unhandled_error: false
            }
        }
    },

    computed: {
        posterUrl () {
            return ''
        },
        posterData () {
            return {}
        }
    },

    methods: {

        posterPost () {
            if (this.poster.submitted) {
                return
            }

            this.poster.submitted = true
            this.poster.unhandled_error = false
            this.former.unhandled_error = false

            axios.post(
                this.posterUrl,
                this.posterData
            )
                .then(response => {
                    console.log('poster response')
                    console.log(response.data)

                    this.posterSuccess(response.data)

                    this.former.errors = {}
                    this.poster.unhandled_error = false
                    this.former.unhandled_error = false
                })
                .catch(error => {
                    // alert('Sparing misslyckades, vänligen försök igen.')
                    console.log('poster failed to post')
                    console.log(error.response)

                    this.posterFail(error.response)

                    if (error.response && error.response.status === 422) {
                        this.former.errors = error.response.data.errors
                        return
                    }

                    this.poster.unhandled_error = true
                    this.former.unhandled_error = true
                })
                .then(response => {
                    this.poster.submitted = false
                })
        },

        posterSuccess (data) {

        },

        posterFail (response) {

        }

    }
}
